import { OrderModifierGroups } from ".."
import { OrderProductModel } from "../../models"

type Props = {
  product: OrderProductModel
}

const OrderProduct: React.FC<Props> = ({product}) => {
  return (
    <>
      <span className="d-block fw-bold">{product?.product_name?.toUpperCase()}</span>

      <OrderModifierGroups modifierGroups={product?.modifier_groups || []} />

      {product.product_instruction && <i>{product.product_instruction}</i>}
    </>
  )
}

export default OrderProduct